import setGrabCursor from '/expert/mobile/setGrabCursor.js';
import unsetGrabCursor from '/expert/mobile/unsetGrabCursor.js';

export default {
  setGrabCursor,
  unsetGrabCursor,
};
